import { useState } from 'react'
import { useContext, useContextSelector } from 'use-context-selector'

import { PromoPageStateContext } from 'states/PromoPageState/PromoPageStateProvider'
import { saveSection } from 'states/PromoPageState/reducer'
import { SectionState } from 'states/PromoPageState/state'
import { SortingCenterType } from 'sections/PromoSection/pages/ListPages/ListSignBoardsSortingCentersPage/types'
import { BlockWrap } from 'components/AdminV2/BlockWrap/BlockWrap'
import { AdminAddElemButton } from 'components/AdminV2/UI/AddElemButton/AdminAddElemButton'
import { AdminInput } from 'components/AdminV2/UI/Input/AdminInput'
import { SectionName, SortingCentersData } from 'types/types'

import { SortingCenterBlockItem } from './SortingCenterBlockItem/SortingCenterBlockItem'

export const SortingCentersBlock = () => {
  const state = useContextSelector(PromoPageStateContext, (context) =>
    context.state.sections.find((section) => section.type === SectionName.sortingCenters),
  ) as SectionState

  const ctx = useContext(PromoPageStateContext)

  const [localPromoState, setLocalPromoState] = useState<SectionState>(state)
  const [title, setTitle] = useState(localPromoState.title)

  const sortingCenters: SortingCenterType[] = (localPromoState.content as SortingCentersData).sortingCentersData

  const addSortingCenterHandler = () => {
    const state = { ...localPromoState }
    const data = (state.content as SortingCentersData).sortingCentersData

    data.push({
      index: data.length,
      address: '',
      city: '',
      workTime: '',
    })

    setLocalPromoState(state)
  }

  const handleConferenceSave = (sortingCenter: SortingCenterType) => {
    const state = { ...localPromoState }
    const sortingCenters = (state.content as SortingCentersData).sortingCentersData

    sortingCenters[sortingCenter.index] = sortingCenter
    sortingCenters.sort((a, b) => a.city.localeCompare(b.city))

    for (let i = 0; i < sortingCenters.length; i++) {
      sortingCenters[i].index = i
    }

    setLocalPromoState(state)
    ctx.dispatch(saveSection(state))
  }

  return (
    <>
      <AdminInput label="Заголовок" labelWeight={600} value={title} onChange={setTitle} />

      {sortingCenters?.map((sortingCenter, index) => (
        <BlockWrap
          key={`${sortingCenter.city}-${sortingCenter.index}`}
          type={SectionName.sortingCenters}
          text={index + 1 + '. ' + sortingCenter.city}
          textFontSize={16}
        >
          <SortingCenterBlockItem
            index={index}
            localPromoState={localPromoState}
            setLocalPromoState={setLocalPromoState}
            sortingCenter={sortingCenter}
            handleSave={handleConferenceSave}
          />
        </BlockWrap>
      ))}

      <AdminAddElemButton text="Добавить сортировочный центр" onClick={addSortingCenterHandler} />
    </>
  )
}
